import { render, staticRenderFns } from "./UserAccountList.vue?vue&type=template&id=5e63e8ff&scoped=true"
import script from "./UserAccountList.vue?vue&type=script&lang=js"
export * from "./UserAccountList.vue?vue&type=script&lang=js"
import style0 from "./UserAccountList.vue?vue&type=style&index=0&id=5e63e8ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63e8ff",
  null
  
)

export default component.exports